import { AnimatePresence, motion } from 'framer-motion';
import { createPortal } from 'react-dom';
import Button from './Button';

export default function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', danger, loading, onConfirm, onCancel }) {
  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Backdrop - always covers full viewport */}
          <div
            className="absolute inset-0 bg-navy-900/40 backdrop-blur-sm"
            onClick={onCancel}
          />
          {/* Modal */}
          <div
            className="absolute inset-0 flex items-center justify-center p-4"
            onClick={onCancel}
          >
          <motion.div
            className="relative bg-white rounded-2xl shadow-elevated max-w-md w-full p-6"
            onClick={e => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
          >
            <h3 className="text-lg font-bold text-navy-900 mb-2">{title}</h3>
            <p className="text-sm text-navy-500 mb-6">{message}</p>
            <div className="flex justify-end gap-3">
              <Button variant="secondary" size="sm" onClick={onCancel}>Cancel</Button>
              <Button variant={danger ? 'danger' : 'primary'} size="sm" loading={loading} onClick={onConfirm}>
                {confirmLabel}
              </Button>
            </div>
          </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
